import React from 'react';

const Cell = ({ data, mapper, Template, className, rowIndex }) => {
  const value = mapper ? mapper(data) : data;

  return <td className={className}>{Template ? <Template data={value} index={rowIndex}/> : value}</td>;
};

export default Cell;
